/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ActivitiesBoardDeleteController',ActivitiesBoardDeleteController);

    ActivitiesBoardDeleteController.$inject = ['$uibModalInstance', 'entity', 'Activities'];

    function ActivitiesBoardDeleteController($uibModalInstance, entity, Activities) {
        var vm = this;

        vm.activities = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Activities.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
